/* componente per la visualizzazione dei dettagli del percorso scelto*/
import React from 'react';
import ovalStart from './initialOval.png'
import OrariFermataPop from './Orari fermata/OrariFermata'
import ovalEnd from '../../Mappa/Polyline/OvalEnd.png'
import arrowDown from './arrowDown.svg'
import arrowUp from './arrowUp.svg'
import './RenderLegsStyle.css';
import {switchMezziImage} from './SwitchMezziImage'
import {switchStepArrow} from './SwitchStepFunction'
import {parsinghour} from './TimeFunction'
import {convertOra} from './TimeFunction'
import convertData from './DateFunction'
import switchAgencyImage from './SwitchAgencyImage'
import { Trans } from 'react-i18next';
import {useTranslation} from 'react-i18next'
import { applyMiddleware } from 'redux';
import iconMW from './mw.gif'

export default class ShowDettagli extends React.Component {
    render() {
        const {data,realTime} = this.props
      
        return (
            <div>
                <ul>
                    {data.legs.map((item, index) => (
                         <RenderLegs realTime={realTime} key={index} item={item} index={index} count={data.legs.length} />
                    ))}
                     </ul>
            </div>
        )
    }
}



function RenderLegs(props){
      return(
        <div >
          <RenderStep realTime={props.realTime} data={props.item} index={props.index} count={props.count}/>
        </div>
      )
}

function RenderInformazioni(data,realTime){
        switch (data.mode){
          case 'WALK':
              return RenderMezzoPrivato(data)
          case 'BUS':
            return RenderMezzoPubblico(data,realTime)
          case 'CAR':
            return RenderMezzoPrivato(data)
          case 'RAIL':
            return RenderMezzoPubblico(data,realTime) 
          case 'TRAM':
            return RenderMezzoPubblico(data,realTime)
          case 'SUBWAY':
            return RenderMezzoPubblico(data,realTime)
          case 'FUNICULAR':
            return RenderMezzoPubblico(data,realTime)  
           case 'GONDOLA':
            return RenderMezzoPubblico(data,realTime)
          case 'BICYCLE':
            return RenderMezzoPrivato(data)
          case 'FERRY':
            return RenderMezzoPubblico(data,realTime)
          case 'AIRPLANE':
            return RenderMezzoPubblico(data,realTime)
          default:
            break;
        }

}



function RenderMezzoPubblico(data,realTime){
  const [openDiv, setOpenDiv] = React.useState(false)
  const handlerClick = () => {
      setOpenDiv(!openDiv)
  } 
  const {t} = useTranslation();

  return (
    <div>
          <div className={"partenzaPublic"}>{data.from.name}</div> 
          <div className={"contenitoreInformazioniPublic"}>
          <div className={"linePublic"} style={switchColor(data)}>{data.route}</div>
          <div className={"headsignPublic"}>{data.headsign}</div>
          <div className={"informazioneDate"}> {convertData(data.startTime,t('it'))}</div>
          <div className={"tempistichePublic"} > <Trans>Circa</Trans> {parsinghour(data.duration)}</div>
          { /*realTime ? <OrariFermataPop data={data}/> : null*/}
          <button className={"informazioniButton"} onClick={handlerClick}>
              <img className={"arrowImage"} src={ openDiv ? arrowUp : arrowDown } alt="start"></img>
              <Trans>Dettaglio fermate</Trans></button>
              { openDiv ? <div className={"moreInformation"}>
                       
                <Trip tripId={data.tripId} from={data.from.stopId} to={data.to.stopId}/>
              </div> : null}
          <div className={"agencyContainer"}>
            {/* <img className={"agencyImage"} src={switchAgencyImage(data.agencyId)} alt="start" /> */}
            <img className={"agencyImage"} 
            src={`/etlsharedrupal/loghi/${data.agencyId}.svg`} 
            alt="" 
            onError={({ currentTarget }) => {
            currentTarget.onerror = null; // prevents looping
            currentTarget.src="/etlsharedrupal/loghi/default.svg";
            }} />
            
            <a className={"agencyInformation"} href={data.agencyUrl}>{data.agencyName}</a>
          </div>
          </div>
    </div>
  )
}

function Trip(props) {
  const [data,setData] = React.useState([])
  // var image = ovalStart

  const newIamge = (propsIn,item) =>{
    var image = ovalStart

    propsIn.from === item.id ? image = ovalEnd : (propsIn.to === item.id) ? image = ovalEnd : image = ovalStart
    return image
  }
  React.useEffect(() => {  
        
    let active = true;
    (async () => {
        const response = await fetch(`${window.configFile.httpProxy.urlOTP}/index/trips/${props.tripId}/stops`,{headers: window.tp_headers});
        const jsonresponse = await response.json();
        if (active) {
            setData(Object.values(jsonresponse));
        }
      })();

      return () => {
        active = false;
      };
    }, [props]);

    return(
        <div> 
            {selectedStops(data,props.from,props.to).map((item,index) => (
              // (props.from === item.id ? image = ovalEnd : (props.to === item.id) ? image = ovalEnd : image = ovalStart),
                <div className={"tripListContainer"} key={index}>
                    <img className={"imageStyleTrip"} src={newIamge(props,item)} alt="start"/> 
                    {item.name} 
                </div>

            ))}
        </div>
    )
}

const selectedStops = (data, from, to) =>{
  let flag = false
  let array = []
  data.map(item =>{
    if (item.id === to){flag=false}
    if (flag) {array.push(item)}
    if (item.id === from) {flag=true}
    return null
  })
  return array
}

function RenderMezzoPrivato(data){
  const {t} = useTranslation();
  const [openDiv, setOpenDiv] = React.useState(false)
  const handlerClick = () => {
      setOpenDiv(!openDiv)
  } 
  const switchModalita = (mode) => {
    switch (mode) {
      case "WALK":
        
        return <Trans>A piedi</Trans>
    
      case "CAR":
        
          return <Trans>In Macchina</Trans>
      case "BICYCLE":
        
          return <Trans>In bicicletta</Trans>
      default:
        break;
    }
  }
  return (
    <div>
          <div className={"partenzaPrivata"}>{(data.from.name === "Origin") ? <Trans>Punto di partenza</Trans> : data.from.name}</div> 
          <div className={"contenitoreInformazioniPublic"}>
              <div className={"informazioneDate"}> {convertData(data.startTime,t('it'))}</div>
              <div className={"informazioneModalita"}>{switchModalita(data.mode)}</div>
              <div className={"tempistichePublic"} > <Trans>Circa</Trans> {parsinghour(data.duration)}, {parseInt(data.distance)} m</div>
              
              <button className={"informazioniButton"} onClick={handlerClick}>
                  <img className={"arrowImage"} src={ openDiv ? arrowUp : arrowDown } alt="start"></img>
                  <Trans>Informazioni</Trans>
              </button>
              { openDiv ? <div className={"moreInformation"}>
                       
                       {data.steps.map((item, index) => (
                       <div className={"testo"} key={index}>{switchStepArrow(item)}</div>
                       ))}
              </div> : null}
          </div>
    </div>
  )
}
function MiddlewarePartenza(props){
  
  const { data,realTime } = props;
  if(props.data.realTime === true){
    return(<div className={"startOra2"}><img src={iconMW}></img>{convertOra(data.startTime)}</div> )
  }else{
    return(<div className={"startOra"}>{convertOra(data.startTime)}</div>)
  }
}
function MiddlewareArrivo(props){
  
  const { data,realTime } = props;
  if(props.data.realTime === true){
    return(<div className={"endOra2"}><img src={iconMW}></img>{convertOra(data.endTime)}</div> )
  }else{
    return(<div className={"endOra"}>{convertOra(data.endTime)}</div>)
  }
}


function RenderStep(props){
  const { data,realTime } = props;
  
  return(
    <div className={"renderStep"}>

      <div className={"dataora"}> 
      {MiddlewarePartenza(props)}      
        {/* <div className={"startOra"}>{convertOra(data.startTime)}</div> */}
          <div className={"imageWalk"}>
              {switchMezziImage(data.mode)}
          </div>
          {MiddlewareArrivo(props)}
          {/* <div className={"endOra"}>{convertOra(data.endTime)}</div> */}
      </div>
      <div>
       <div className={"imageLineOvalStart0"}>
              <img className={"imageStyle"} src={ovalStart} alt="start"/>
          </div> 
      <div className={"line"}>

          <div className={"imageLineOvalStart0"}>

            {drawLine(data)}
          </div>
          <div className={"imageLineOvalEnd0"}>
          {(props.index === props.count -1) ? <img className={"imageStyle"} src={ ovalEnd } alt="start"/> : null}
          </div>
      </div>
      </div>
      <div className={"informazioni"}>
        {RenderInformazioni(data,realTime)}
      </div>
    </div>
  )
}


  


function drawLine(data) {
  return (
    <div className={"dot"} style={switchColor(data)}>

    </div>
  )
}
//funzione per associare a ogni mezzo un colore
function switchColor(data) {
  switch (data.mode){
    case 'WALK':
      return {backgroundColor: "trasparent", borderColor: '#007ac9',borderLeft: '7px dotted #007ac9', position: 'relative', left: '3px'}
    case 'BUS':
      return  {backgroundColor: "#007ac9"}
    case 'CAR':
      return {backgroundColor: "#01754B"}
    case 'RAIL':
      return {backgroundColor: "#a30b01"}
    case 'TRAM':
      return {backgroundColor: "#00985f"}
    case 'SUBWAY':
      return {backgroundColor: "#00985f"}
    case 'FUNICULAR':
      return {backgroundColor: "#00985f"}
     case 'GONDOLA':
      return {backgroundColor: "#00985f"}
    case 'BICYCLE':
      return  {backgroundColor: "#f2b62d"}
    case 'FERRY':
      return {backgroundColor: "#00b9e4"}
    case 'AIRPLANE':
      return {backgroundColor: "#12b08b"}
    default:
      break;
  }
}

